// Dossier op de calculatiepagina (feedback 28 okt 2026): notities met collega's taggen, labels en
// de laatste wijzigingen staan meteen zichtbaar bovenaan, in plaats van achter een link.
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { api, type TagRij } from '../lib/api';
import { Notities, type NotitieFocus } from './Notities';
import { RecenteWijzigingen } from './ProjectLog';
import { ProjectTags } from './Tags';

export function DossierPaneel({ sleutel, calcId, tags, focus, labelSignaal }: {
  sleutel: string;
  calcId: string;
  tags: TagRij[];
  focus: NotitieFocus | null;
  labelSignaal: number;
}) {
  const notitiesQ = useQuery({ queryKey: ['notities', sleutel], queryFn: () => api.dossier.notities(sleutel) });
  // Zelfde sleutel als de volledige projectlog zonder filter: de cache wordt gedeeld.
  const logQ = useQuery({ queryKey: ['projectlog', sleutel, '', ''], queryFn: () => api.dossier.log(sleutel) });
  const notities = notitiesQ.data?.notities ?? [];
  const volledigeLog = `/projectnummer/${encodeURIComponent(sleutel)}`;

  return (
    <section id="dossier" aria-labelledby="dossier-titel" className="card mb-5 normal-case tracking-normal">
      <div className="grid gap-x-6 gap-y-5 lg:grid-cols-[minmax(0,3fr)_minmax(0,2fr)]">
        <div className="min-w-0">
          <h2 id="dossier-titel" className="text-base font-bold mb-3">
            Notities
            {notities.length > 0 && <span className="ml-2 text-sm font-semibold text-secondary">{notities.length}</span>}
          </h2>
          {notitiesQ.isError
            ? <p className="text-sm text-danger">De notities konden niet geladen worden.</p>
            : <Notities sleutel={sleutel} notities={notities} calcId={calcId} ingebed focus={focus} />}
        </div>

        <div className="min-w-0 lg:border-l lg:border-lightgrey lg:pl-6">
          <h2 className="text-base font-bold mb-2">Labels</h2>
          <div className="mb-5">
            <ProjectTags sleutel={sleutel} tags={tags} openSignaal={labelSignaal} />
          </div>

          <div className="flex items-baseline justify-between gap-3 mb-2">
            <h2 className="text-base font-bold">Laatste wijzigingen</h2>
            <Link to={volledigeLog} className="text-xs font-semibold text-accent-700 hover:underline">Volledige projectlog</Link>
          </div>
          {logQ.isLoading
            ? <p className="text-sm text-secondary">Laden…</p>
            : logQ.isError
              ? <p className="text-sm text-danger">De projectlog kon niet geladen worden.</p>
              : <RecenteWijzigingen entries={logQ.data?.entries ?? []} max={4} />}
        </div>
      </div>
    </section>
  );
}
